import { render } from "./RuleListView.vue?vue&type=template&id=15452972"
import script from "./RuleListView.vue?vue&type=script&lang=js"
export * from "./RuleListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/RuleListView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15452972"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15452972', __exports__)) {
    api.reload('15452972', __exports__)
  }
  
  module.hot.accept("./RuleListView.vue?vue&type=template&id=15452972", () => {
    api.rerender('15452972', render)
  })

}


export default __exports__